import { useState } from 'react';
import { Box, Chip, Typography } from '@material-ui/core';

import { Alert } from '@material-ui/lab';
import FormSection from '../../../../components/atom/FormSection';
import SeatingIframe from './SeatingIframe';

function FireKnifeSeatsInfo({ cartItem, updateCartItem }) {
    const providerData = cartItem?.providerData['FireKnifeApi'] || {};
    const { timeslotId, showId, widgetUrl } = providerData;
    const ticketTypeId = parseInt(providerData.ticketTypeId, 10) || 0;

    // Map cart tickets to the iframe format: { ticketTypeId, ticketOptionId, quantity }
    const iframeTickets =
        cartItem?.tickets
            .filter(t => t.quantity > 0)
            .map(t => ({
                ticketTypeId,
                ticketOptionId: parseInt(t.vendor_sku, 10) || 0,
                quantity: t.quantity
            })) || [];

    const [selectedSeats, setSelectedSeats] = useState([]);
    const [seatsConfirmed, setSeatsConfirmed] = useState(false);
    const [noSeatingRequired, setNoSeatingRequired] = useState(false);

    if (!widgetUrl) {
        // silent error
        console.error('No seating widget URL configured for this activity.');
        return null;
    }

    return (
        <FormSection title="Seats information">
            <Box mb={2} style={{ width: '100%' }}>
                {selectedSeats.length > 0 && (
                    <Box mb={2}>
                        <Typography variant="subtitle1" style={{ fontWeight: 500 }}>
                            Selected Seats:
                        </Typography>
                        <Box mt={1} display="flex" style={{ gap: 10, flexWrap: 'wrap' }}>
                            {selectedSeats.map(seat => (
                                <Chip
                                    key={seat.seatId}
                                    label={seat.label}
                                    color={seatsConfirmed ? 'primary' : 'default'}
                                />
                            ))}
                        </Box>
                        {!seatsConfirmed && (
                            <Typography variant="body2" color="error" style={{ marginTop: 8 }}>
                                Please complete your seat selection.
                            </Typography>
                        )}
                    </Box>
                )}
                {selectedSeats.length === 0 && !noSeatingRequired && (
                    <Alert severity="info" style={{ marginBottom: 20 }}>
                        Please select your seats from the map below.
                    </Alert>
                )}
                <SeatingIframe
                    src={widgetUrl}
                    showId={showId}
                    timeSlotId={timeslotId}
                    tickets={iframeTickets}
                    selectedSeats={selectedSeats}
                    onSeatSelected={seat => setSelectedSeats(prev => [...prev, seat])}
                    onSeatDeselected={seat =>
                        setSelectedSeats(prev => prev.filter(s => s.seatId !== seat.seatId))
                    }
                    onSeatsUpdated={seats => setSelectedSeats(seats)}
                    onNoSeatingRequired={() => {
                        setNoSeatingRequired(true);
                        updateCartItem([], true);
                    }}
                    onSeatsConfirmed={({ confirmed, seats }) => {
                        setSeatsConfirmed(confirmed);
                        setSelectedSeats(seats);
                        updateCartItem(
                            seats.map(s => ({
                                id: s.seatId,
                                name: s.label
                            })),
                            confirmed
                        );
                    }}
                />
            </Box>
        </FormSection>
    );
}

export default FireKnifeSeatsInfo;
